<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 12:02:05
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 15:44:46
 * @FilePath: \zhucai_user\src\pages\member\child\info.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">任务台账-人员进度明细</div>
    <div class="my-content">
      <div class="my-info">
        <div class="my-info-item">
          <div class="my-info-item-title">任务状态：</div>
          <div class="my-info-item-content statusName">
            {{ info.StatusTxt }}
          </div>
        </div>
        <div class="user-info">
          <div class="user-info-item">
            <div class="user-info-item-title">姓名：</div>
            <div class="user-info-item-content">{{ UserDetail.RealName }}</div>
          </div>
          <div class="user-info-item">
            <div class="user-info-item-title">性别：</div>
            <div class="user-info-item-content">{{ UserDetail.SexTxt }}</div>
          </div>
          <div class="user-info-item width50">
            <div class="user-info-item-title">学习进度：</div>
            <div class="user-info-item-content StudyProgress">
              {{ UserDetail.StudyProgress }}%
            </div>
          </div>
          <div class="user-info-item">
            <div class="user-info-item-title">手机账号：</div>
            <div class="user-info-item-content">{{ UserDetail.Phone }}</div>
          </div>
          <div class="user-info-item">
            <div class="user-info-item-title">身份证号：</div>
            <div class="user-info-item-content">{{ UserDetail.IDCard }}</div>
          </div>
          <div class="user-info-item">
            <div class="user-info-item-title">学习时长(分钟)：</div>
            <div class="user-info-item-content">
              {{ UserDetail.StudyDuration }}
            </div>
          </div>
          <div class="user-info-item">
            <div class="user-info-item-title">考试结果：</div>
            <div class="user-info-item-content">
              {{ UserDetail.ExamResult }}
            </div>
          </div>
        </div>
        <div class="my-info-item alignCenter">
          <div class="my-info-item-title">所属单位：</div>
          <div class="my-info-item-content bg666">{{ info.OrgnName }}</div>
        </div>
        <div class="my-info-item alignCenter">
          <div class="my-info-item-title">任务时间：</div>
          <div class="my-info-item-content times">
            <div class="bg666">{{ info.StartTimeTxt }}</div>
            <div>-</div>
            <div class="bg666">{{ info.EndTimeTxt }}</div>
          </div>
        </div>
        <div class="my-info-item alignCenter">
          <div class="my-info-item-title">任务名称：</div>
          <div class="my-info-item-content bg666">
            {{ info.TaskName }}
          </div>
        </div>
        <div class="my-info-item">
          <div class="my-info-item-title">课程：</div>
          <div class="my-info-item-content">
            <el-table :data="info.CourseList">
              <el-table-column prop="ImgPath" label="封面" width="120">
                <template slot-scope="scope">
                  <div class="course-imgBox">
                    <img :src="scope.row.ImgPath" @error="imgError" />
                  </div> </template
              ></el-table-column>
              <el-table-column
                prop="CourseName"
                label="课程名称"
                min-width="300"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="StudyProgress"
                label="学习进度"
                width="180"
                align="center"
              >
                <template slot-scope="scope">
                  <span class="StudyProgress"
                    >{{ scope.row.StudyProgress }}%</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="my-info-item">
          <div class="my-info-item-title">练习：</div>
          <div class="my-info-item-content">
            <el-table :data="info.ExerciseList">
              <el-table-column
                prop="ExerciseName"
                label="练习名称"
                align="left"
              >
              </el-table-column>
              <el-table-column prop="TotalNum" label="题量" align="center">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="my-info-item">
          <div class="my-info-item-title">考试：</div>
          <div class="my-info-item-content">
            <p class="CertLevel">
              关联证书：{{ info.CertName }}（{{ info.CertLevel }}）
            </p>
            <el-table :data="info.PaperList">
              <el-table-column
                prop="PaperName"
                label="试卷名称"
                min-width="200"
                align="left"
              >
              </el-table-column>
              <el-table-column
                prop="PaperModTxt"
                label="组卷方式"
                align="center"
                width="120"
              >
              </el-table-column>
              <el-table-column
                prop="TotalNum"
                label="题量"
                align="center"
                width="120"
              >
              </el-table-column>
              <el-table-column
                prop=""
                label="及格分/总分"
                align="center"
                width="120"
              >
                <template slot-scope="scope">
                  <span>{{
                    scope.row.PassScore + "/" + scope.row.TotalScore
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="Duration"
                label="考试时长（分钟）"
                width="180"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="ExamTypeTxt"
                label="考试模式"
                width="150"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="ExamResult"
                label="考试结果"
                width="150"
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="my-info-item mt30 ml100">
        <el-button class="submit-btn" @click="back"> 返回 </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  OrgnManage_GetTaskUserDetail,
  OrgnManage_GetTaskUserList,
} from "@/api/member";

/* eslint-disable */
export default {
  name: "userTaskProgress",
  data() {
    return {
      isloading: true,
      UserDetail: {},
      info: {},
    };
  },

  mounted() {
    this.getInfo();
  },

  methods: {
    back() {
      this.$router.push({
        path: "/member/taskLedgerDetail",
        query: { TaskID: this.$route.query.TaskID },
      });
    },
    getInfo() {
      OrgnManage_GetTaskUserDetail({
        TaskID: this.$route.query.TaskID,
        UserID: this.$route.query.UserID,
      })
        .then((res) => {
          this.info = res.data.TaskDetail;
          this.UserDetail = res.data.UserDetail;
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info {
  margin-left: 10px;
  margin-bottom: 20px;
  background: #eceef1;
  border-radius: 10px;
  padding: 25px;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  .user-info-item {
    width: 25%;
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    .user-info-item-title {
      // width: 100px;
      font-weight: 400;
      font-size: 18px;
      text-align: left;
      color: #666666;
    }
    .user-info-item-content {
      color: #333333;
      font-weight: 400;
      font-size: 18px;
    }
    .bold {
      color: #333333;
    }
    .Amount {
      font-weight: bold;
      font-size: 20px;
      color: #e12a14;
    }
  }
  .width50 {
    width: 50%;
  }
}
.CertLevel {
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  margin-bottom: 20px;
}
.course-imgBox {
  width: 56px;
  height: 42px;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }
}
.StudyProgress {
  font-weight: 900 !important;
  font-size: 18px !important;
  color: #1d79ff !important;
}
.my-info {
  .bg666 {
    width: 640px;
    height: 46px;
    line-height: 46px;
    padding-left: 15px;
    background: #eceef1;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
  }
  .times {
    display: flex;
    align-items: center;
    gap: 15px;
    .bg666 {
      width: 300px;
    }
  }
  .alignCenter {
    align-items: center;
  }
  .my-info-item {
    display: flex;

    margin-bottom: 20px;

    .my-info-item-title {
      text-align: right;
      width: 100px;
      font-weight: 400;
      font-size: 18px;
      color: #666666;
    }
    .my-info-item-content {
      color: #333333;
      font-weight: 400;
      font-size: 18px;
      .el-table {
        width: 1240px;
      }
    }
    .bold {
      color: #333333;
    }
    .Amount {
      font-weight: bold;
      font-size: 20px;
      color: #e12a14;
    }
  }
}
.Amount {
  font-weight: bold;
  font-size: 20px;
  color: #e12a14;
}
.title {
  font-size: 20px;
  color: #333333;
  margin-bottom: 10px;
}

.statusName {
  font-size: 20px !important;
  color: #1d79ff !important;
}
.submit-btn {
  width: 144px;
  height: 52px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
}
</style>
